module.exports = __webpack_public_path__ + "img/pie.14e72c57.png";